import Loading from '../../../components/Loading';
import { Pagination } from '../../../components/Pagination';
import { useQuery } from '../../../utils/useQuery';
import { useTranslation } from 'react-i18next';
import { useSetFilters } from '../../../hooks/useSetFilters';
import { CustomSelect } from '../../../components/Shared/CustomSelect';
import { FormField } from '../../../components/FormField';
import { Breadcrumbs } from '../../../components/Breadcrumbs';
import { useGetStatements } from '../../../network';
import { StatementsFilter } from './StatementsFilter';
import { RoundedBox } from '../../../components/Shared/RoundedBox';
import { StatementsTable } from './StatementsTable';

export const Statements = () => {
    const setFilters = useSetFilters();
    const { t } = useTranslation();
    const query = useQuery();

    const page = parseInt(query.get('page') || '') || 1;
    const perPage = parseInt(query.get('per_page') || '') || 10;
    const by = query.get('by') || ''; // weekly, monthly, custom
    const chain = parseInt(query.get('chain') || ''); // weekly, monthly, custom

    const { data = {}, isLoading, isRefetching, refetch } = useGetStatements();

    const statements = data.data || [];

    const filteredByChain = chain? statements.filter((statement) => statement.chain_id === chain) : statements;
    const filteredStatementsByTime = by ? filteredByChain.filter((statement) => statement.type === by) : filteredByChain;

    const total = filteredStatementsByTime.length;
    const numPages = Math.ceil(total / perPage || 1);
    const paginatedStatements = filteredStatementsByTime.slice((page - 1) * perPage, page * perPage);

    const setCurrentPage = (page) => setFilters({ page });
    const onChangePerPage = ({ value }) => setFilters({ per_page: value, page: 1 });

    const pages = [{ name: t('Statements'), path: '/admin/transactions-statements' }];

    return (
        <div className="py-3 w-full flex justify-center">
            <div className="max-w-7xl  w-full">
                <div className="flex gap-6 items-center">
                    <Breadcrumbs pages={pages} />
                </div>
                <StatementsFilter refetch={refetch} />

                <div className="flex mt-5">
                    <div className="w-full ">
                        <div className="flex flex-col">
                            <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                    <div>
                                        <Loading loading={isLoading || isRefetching}>
                                            {paginatedStatements.length !== 0 && <StatementsTable statements={paginatedStatements} />}
                                            {paginatedStatements.length === 0 && (
                                                <RoundedBox className="p-8 flex justify-center">
                                                    <h1 className="text-2xl">Statements list is empty</h1>
                                                </RoundedBox>
                                            )}
                                            <div className="flex justify-center items-center pt-3 pb-3">
                                                <Pagination className="ml-12" numPages={numPages} currentPage={page} setCurrentPage={setCurrentPage} />
                                                <FormField className="ml-5">
                                                    <CustomSelect
                                                        isSearchable={false}
                                                        defaultValue={{ label: perPage, value: perPage }}
                                                        onChange={onChangePerPage}
                                                        menuPlacement="top"
                                                        options={[
                                                            { label: 5, value: 5 },
                                                            {
                                                                label: 10,
                                                                value: 10,
                                                            },
                                                            { label: 20, value: 20 },
                                                            {
                                                                label: 50,
                                                                value: 50,
                                                            },
                                                            { label: 100, value: 100 },
                                                        ]}
                                                    />
                                                </FormField>
                                            </div>
                                        </Loading>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
